// AI: justified because the generated client (`@app/api-client/generated`) is not
// available until `pnpm api:generate` has been run at least once. After the first
// generation, this file MUST be deleted and the generated hooks used instead.

import { apiAxios } from '@app/api-client';
import type { SiteCreateInput, SiteDto, SiteUpdateInput } from '@app/contracts';

export const fetchSites = (): Promise<SiteDto[]> =>
  apiAxios<SiteDto[]>({ url: '/api/v1/sites', method: 'GET' });

export const createSite = (input: SiteCreateInput): Promise<SiteDto> =>
  apiAxios<SiteDto>({ url: '/api/v1/sites', method: 'POST', data: input });

export const updateSite = (id: string, input: SiteUpdateInput): Promise<SiteDto> =>
  apiAxios<SiteDto>({ url: `/api/v1/sites/${id}`, method: 'PATCH', data: input });

export const deleteSite = (id: string): Promise<void> =>
  apiAxios<void>({ url: `/api/v1/sites/${id}`, method: 'DELETE' });
